import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {

    useEffect(() => {
      AOS.init({
      duration: 1400, 
      easing: 'ease-in-cubic',
      once: true,
      offset: 80,    
      });
    }, []);
  

  const handleScroll = () => {
    window.scrollBy({
      top: 500,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="text-gray-600 body-font px-4 sm:px-6 md:px-20">
        <div className="container mx-auto flex px-5 py-16 md:flex-row flex-col items-center">

          <div data-aos="zoom-in" data-aos-delay="900"
            className="lg:max-w-lg lg:w-full md:w-1/2 w-full mb-10 md:mb-0">
            <img
              className="object-cover object-center rounded w-full h-auto"
              alt="hero"
              src="/images/about.png"
            />
          </div>

          <div className="lg:flex-grow md:w-1/2 lg:pl-16 md:pl-12 flex flex-col md:items-start md:text-left items-center text-center">

            <h2 data-aos="fade-up" data-aos-delay="1000"
              className="title-font sm:text-4xl text-3xl mb-6 font-semibold text-gray-900">
              Who We Are?
            </h2>

            <p data-aos="fade-up" data-aos-delay="1100"
              className="mb-6 leading-relaxed text-gray-700"
              style={{ textAlign: "justify" }}>
              We are a passionate team at{" "}
              <span className="text-[#d09714] font-semibold">
                EZ Technologies & Learning Hub
              </span>
              , offering custom website development, digital marketing, and
              digital skills development.
            </p>

            <p data-aos="fade-up" data-aos-delay="1200"
              className="mb-6 leading-relaxed text-gray-700"
              style={{ textAlign: "justify" }}>
              Our{" "}
              <span className="text-[#d09714] font-semibold">vision</span> is to
              empower both businesses and individuals...
            </p>

            <div data-aos="fade-up" data-aos-delay="1300"
              className="flex justify-center md:justify-start">
              <button
                onClick={handleScroll}
                className="font-fancy font-bold inline-flex text-[#010000f5] bg-[#d6b055] border-0 py-2 px-3 focus:outline-none hover:bg-[#010000f5] hover:text-white rounded text-lg">
                Explore More
              </button>
            </div>

          </div>
        </div>
      </section>
      <hr />
    </div>
  );
};

export default About;